import { SET_DRIVERS_LIST_IN_STORE, SET_VEHICLES_LIST_IN_STORE } from './types';

export const setVehiclesListInStore = (data) => {
  return {
    type: SET_DRIVERS_LIST_IN_STORE,
    data,
  };
};
export const setVehiclesInStore = (data) => {
  return {
    type: SET_VEHICLES_LIST_IN_STORE,
    data,
  };
};
